import React, { Component} from 'react';

import Select from '../Select';

const data = [
    {value: "0", label: "当前窗口"},
    {value: "1", label: "新窗口"}
];

const ModuleType = (props) => (
    <Select name="target" label="窗口" data={data} {...props} ></Select>
);

export default ModuleType;